import { useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";

import { SetReminders } from "data/reminders/actions";

import { useQuery } from "hooks";

import toGlobalId from "scenes/Hubly/components/Workspace/api/helper";

import { useSubscribeToClientCardUpcomingReminders } from "./useSubscribeToClientCardUpcomingReminders";

export function useUpcomingReminders(clientId) {
  const dispatch = useDispatch();

  const queryFactory = useCallback(() => {
    const query = `query getUpcomingReminders($clientId: ID) {
      reminders(orderBy: "time", client: $clientId, completedAt_Isnull: true, dismissed: false) {
        edges {
          node {
            uuid
            title
            time
            futureReminderType
            futureReminderTime
            futureReminderNumber
            dismissed
            task {
              title
              uuid
              clientWorkflow {
                uuid
                workflow {
                  uuid
                  name
                }
              }
              formInstance {
                uuid
                isFilled
                name
              }
            }
            client {
              uuid
              firstName
              lastName
            }
          }
        }
      }
    }`;

    const resolver = ({ data }) => {
      const reminders = data.reminders.edges.map(({ node }) => {
        return {
          ...node,
          id: node.uuid,
          taskId: node.task?.uuid,
          clientId: node.client.uuid,
          clientWorkflowId: node.task?.clientWorkflow?.uuid,
          client: {
            ...node.client,
            id: node.client.uuid,
          },
          task: !node.task
            ? undefined
            : {
                ...node.task,
                clientWorkflow: {
                  ...node.task.clientWorkflow,
                  id: node.task.clientWorkflow.uuid,
                },
                id: node.task.uuid,
                formInstanceId: node.task.formInstance?.uuid,
                workflowName: node.task.clientWorkflow.workflow.name,
              },
        };
      });

      dispatch(SetReminders(reminders));

      return reminders;
    };

    return { query, resolver };
  }, [dispatch]);

  const query = useQuery(queryFactory, {
    variables: useMemo(() => {
      return { clientId: toGlobalId("Client", clientId) };
    }, [clientId]),
  });

  useSubscribeToClientCardUpcomingReminders(query.reloadData);

  return query;
}

export default useUpcomingReminders;
